import { FatalErrorReportModel } from './error.model';

export const defaultErrorReport: FatalErrorReportModel = {
  title: `We're unable to find the page you're looking for.`,
  description: `Please check your URL or return to our <a href="/">homepage</a>.`
};

export const defaultContentErrorReport: FatalErrorReportModel = {
  title: `We're unable to find the model you're looking for.`,
  description: `Please check your URL or visit the <a href="/" target="_blank">BioDigital Human</a> to see what's available in our 3D model library.`,
};
